<style>
#scheduleModal .v--modal-box.v--modal {
  min-height: 400px !important;
  min-width: 450px !important;
}
#btn__bookmark--add {
  margin-right: 0;
}
.btn__bookmark {
  height: 15px;
  width: 15px;
  background-color: rgba(0, 0, 0, 0.54) !important;
  transition: 0.2s;
}
.btn__bookmark:hover {
  background-color: #3f67a4 !important;
}
.btn__bookmark__icon {
  font-size: 15px;
}
.group.card__navbar {
  height: 75px;
}
.btn__bookmark__wrapper {
  display: flex;
}
#start {
  max-height: 84px;
}
#start .v-select__selection,
#start .v-select__selection input,
#start div.v-select__slot > label {
  font-size: 12px;
}
#start .v-select__slot {
  max-width: 250px;
}
::-webkit-input-placeholder,
::-moz-input-placeholder {
  font-size: 14px;
}
#start > div > div:nth-child(3) > div > div:nth-child(1) {
  padding-bottom: 0px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div class="group">
      <div class="container__group--rows">
        <div class="ribbon-button ribbon__row">
          <v-select
            id="coordSystemSelect"
            :items="coordSystems"
            @change="changeMouseCoords"
            v-model="currentCoordSystem"
            height="20"
            label="Współrzędne kursora"
          ></v-select>
        </div>
        <div class="ribbon-button ribbon__row">
          <v-select
            :items="bookmarks"
            item-text="name"
            :return-object="true"
            no-data-text="Brak zakładek"
            @change="zoomBookmark"
            v-model="currentBookmark"
            height="20"
            placeholder="Zakładki przestrzenne"
            id="selectStart"
          ></v-select>
          <div class="btn__bookmark__wrapper">
            <v-btn
              class="btn__bookmark"
              id="btn__bookmark--add"
              fab
              dark
              depressed
              @click="show('addBookmarkModal')"
              title="Dodaj zakładkę"
            >
              <v-icon
                dark
                class="btn__bookmark__icon"
              >add</v-icon>
            </v-btn>
            <br>
            <v-btn
              class="btn__bookmark"
              id="btn__bookmark--remove"
              fab
              dark
              depressed
              @click="removeBookmark"
              title="Usuń bieżącą zakładkę"
            >
              <v-icon
                dark
                class="btn__bookmark__icon"
              >remove</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div class="group">
      <div class="container__group--rows">

        <div class="ribbon__row border--bottom">

          <div
            class="ribbon-button ribbon__row--flex"
            @click="show('addRasterModal')"
          >
            <span class="icon">
              <v-icon small>photo</v-icon>
            </span>
            <button class="caption">Dodaj raster</button>
          </div>

        </div>

        <div class="ribbon__row border--bottom">
          <div
            class="ribbon-button ribbon__row--flex"
            @click="show('networkReportModal')"
          >
            <span class="icon">
              <v-icon small>report</v-icon>
            </span>
            <button class="caption">Raport o sieci</button>
          </div>
        </div>

      </div>
    </div>
    <div
      class="more-hidden"
      id="showMore"
    >
      <a href="#">
        <span class="fa fa-ellipsis-h"></span>
      </a>
      <ul class="hidden-menu"></ul>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
export default {
  components: {
    vueCustomScrollbar
  },
  data: () => ({
    currentBookmark: undefined,

    currentCoordSystem: undefined,
    coordSystems: ["2000 (V)", "1992", "WGS84"]
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    bookmarks() {
      return this.$store.getters.getBookmarks;
    },
    /* tableDataActive() {
      return this.$store.getters.getTableDataActive;
    }, */
    currentCoordSystemStorage() {
      return this.$store.getters.getCurrentCoordSystem;
    },
    currentRibbonBookmark() {
      return this.$store.getters.getCurrentBookmark;
    },
    labelsShow() {
      return this.$store.getters.getLabelsShow;
    },
  },
  methods: {
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    changeMouseCoords(value) {
      this.$store.commit("setCurrentCoordSystem", value);
      this.$root.$emit("coordSystemChanged", value);
    },
    zoomBookmark(e) {
      this.$root.$emit("setPosition", [e.center_x, e.center_y, e.zoom]);
    },
    removeBookmark() {
      let index = this.bookmarks.indexOf(this.currentBookmark);
      let payload = this.bookmarks.slice();
      payload.splice(index, 1);
      const self = this;
      this.$emit("confDialogOpened", true);
      self.$modal.show("dialog", {
        title: "Usuwanie zakładki",
        text: "Czy na pewno chcesz usunąć zakładkę?",
        buttons: [
          {
            title: "NIE",
            handler: () => {
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
              return;
            }
          },
          {
            title: "TAK",
            default: true,
            handler: () => {
              self.$store.dispatch("removeBookmark", payload).then(success => {
                if(success) {
                  self.$root.$emit(
                    "showSnackbar",
                    "success",
                    "Pomyślnie usunięto zakładkę"
                  );
                } else {
                  self.$root.$emit(
                    "showSnackbar",
                    "red",
                    "Podczas usuwania zakładki wystąpił błąd"
                  );
                }
              });
              this.$emit("confDialogOpened", false);
              self.$modal.hide("dialog");
            }
          }
        ]
      });
    },
    labelsVisibleToggle() {
      this.$store.commit("setLabelsShow", !this.labelsShow);
    },
  },
  mounted() {
    const self = this;
    this.currentCoordSystem = this.currentCoordSystemStorage;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/start/Start.vue